import React from 'react'
import Pagination from 'rsuite/Pagination'
import './pagination.sass'

interface Props {
    limit: number
    limitOptions: number
    maxButtons: number
    activePage: number
    onchange: (page: number) => void
    total: number
    linkAs?: any
    noPagination?: boolean
}

const PaginationWrapper: React.FunctionComponent<Props> = ({
    limit,
    limitOptions,
    maxButtons,
    activePage,
    onchange,
    total,
    linkAs,
    noPagination = false
}: Props) => {
    return (
        <div className="paginationWrapper">
            <Pagination
                limit={limit}
                //@ts-ignore
                limitOptions={[limitOptions]}
                maxButtons={maxButtons}
                activePage={activePage}
                linkAs={linkAs}
                prev={!noPagination}
                next={!noPagination}
                onChangePage={(page: number) => onchange(page)}
                total={total}
            />
        </div>
    )
}

export default PaginationWrapper
